// extracted by mini-css-extract-plugin
module.exports = {"leaders":"AgreementPage8_leaders__7hwW3","pricingContainer":"AgreementPage8_pricingContainer__1c5B4"};